import { TeligramIcon, TwitterIcon } from "./Icon";
import img1 from "./../assets/png/slider-1-img.png";
import img2 from "./../assets/png/slider-2-img.png";
export const headerLinks = [
  { name: "Home", link: "/" },
  { name: "About", link: "#About" },
  { name: "How to Buy", link: "#HowtoBuy" },
  { name: "Roadmap", link: "#Roadmap" },
  { name: "Community", link: "#Community" },
];
export const mediaLinks = [
  { icon: <TeligramIcon />, link: "https://t.me/JOSHCOINPORTAL" },
  { icon: <TwitterIcon />, link: "https://x.com/joshonsolcoin" },
];
export const sliderData = [
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
  { path: img1 },
  { path: img2 },
];
